import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useBalanceFeatureToggleV2 } from '../../domain/balance/hook/useBalanceFeatureToggleV2'
import { t } from '../../domain/language/languageUtil'

interface SessionTotalStakeProps {
  x: number
  y: number
}

const textStyle = new TextStyle({
  fontFamily: 'Arial',
  fontSize: 24,
  fill: '#ffffff',
})

/** v2 toggle 版的 {@link SessionTotalStake}；幣別顯示改由 `displayCurrency` 決定。 */
export const SessionTotalStakeFeatureToggleV2 = (props: SessionTotalStakeProps) => {
  const { currency, sessionTotalStake } = useBalanceFeatureToggleV2()
  return (
    <Text
      text={`${t('session_total_stake')}: ${sessionTotalStake} ${currency}`}
      x={props.x}
      y={props.y}
      style={textStyle}
      anchor={0.5}
    />
  )
}
